import AemButton from '@/components/AemButton/AemButton';
import RemoteIcon from '@/components/RemoteIcon/RemoteIcon';
import {Text} from '@/components/Typography';
import type {ButtonModel, IconModel} from '@/types/aem';

interface ExplanationCardProps {
    image: IconModel;
    title?: string;
    button?: ButtonModel;
    code?: string;
}

const ExplanationCard = ({image, title, button, code}: ExplanationCardProps) => (
    <div className='relative flex aspect-345/249 flex-col justify-between overflow-hidden rounded-xl p-4'>
        <RemoteIcon icon={image} className='absolute inset-0 size-full object-cover' />
        <Text as='h3' variant='sectionTitle' className='relative text-left text-romance'>
            {title}
        </Text>
        <AemButton button={button} code={code} variant='solid' className='relative' />
    </div>
);

export default ExplanationCard;
